import { graphql } from "../../gql";
import { useQuery } from "@apollo/client";

export const GetMyRemaining1on1Lessons = graphql(`
  query getMyRemaining1on1Lessons {
    getMyRemaining1on1Lessons {
      remainingLessons
      totalAvailableLessons
      planEndDate
      cancellationsUsed
      maxCancellations
    }
  }
`);

export function useMyRemaining1on1Lessons() {
  const { data, loading } = useQuery(GetMyRemaining1on1Lessons);
  return {
    remainingLessons: data?.getMyRemaining1on1Lessons?.remainingLessons ?? 0,
    totalAvailableLessons:
      data?.getMyRemaining1on1Lessons?.totalAvailableLessons ?? 0,
    planEndDate: data?.getMyRemaining1on1Lessons?.planEndDate ?? null,
    has1on1Plan: data?.getMyRemaining1on1Lessons != null,
    cancellationsUsed: data?.getMyRemaining1on1Lessons?.cancellationsUsed ?? 0,
    maxCancellations: data?.getMyRemaining1on1Lessons?.maxCancellations ?? null,
    loading,
  };
}
